/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Menu_Demo_HintInputs */



/**
* | output |
* | --- |
* | "A real dashboard with a busy server in it" |
*
* @param {Marketing_Menu_Demo_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const marketing_menu_demo_hint = /** @type {((inputs?: Marketing_Menu_Demo_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Menu_Demo_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настоящая панель с оживлённым сервером")
	return /** @type {LocalizedString} */ ("A real dashboard with a busy server in it")
});